export const CURRENT_STATE = 'CURRENT_STATE';
export const SET_STATE = 'SET_SETTINGS_STATE';

export const RESET_STATE = 'SETTINGS_RESET_STATE';
export const CURRENT_ITEM = 'SETTINGS_CURRENT_ITEM';

export const REQUEST_LOADING = 'SETTINGS_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'SETTINGS_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'SETTINGS_REQUEST_FAILED';

export const CURRENT_ACTION = 'SETTINGS_CURRENT_ACTION';
export const RESET_ACTION = 'SETTINGS_RESET_ACTION';
